import actionTypes from '../actionTypes'

const creationToolOeqActions = {
	initializeOEQSuccess: payload => ({
		type: actionTypes.CREATION_TOOL_OEQ_INITIALIZE_SUCCESS,
		payload,
	}),
	initializeOEQError: error => ({
		type: actionTypes.CREATION_TOOL_OEQ_INITIALIZE_ERROR,
		error,
	}),
	questionUpdateSuccess: () => ({
		type: actionTypes.CREATION_TOOL_OEQ_QUESTION_UPDATE_SUCCESS,
	}),
	questionUpdateError: error => ({
		type: actionTypes.CREATION_TOOL_OEQ_QUESTION_UPDATE_ERROR,
		error,
	}),
	questionChange: value => ({
		type: actionTypes.CREATION_TOOL_OEQ_QUESTION_CHANGE,
		value,
	}),
	questionSave: jwt => ({
		type: actionTypes.CREATION_TOOL_OEQ_QUESTION_AUTOSAVE,
		jwt,
	}),
	getQuestionSuccess: entity => ({
		type: actionTypes.CREATION_TOOL_OEQ_QUESTION_GET_SUCCESS,
		entity,
	}),
	getQuestionError: error => ({
		type: actionTypes.CREATION_TOOL_OEQ_QUESTION_GET_ERROR,
		error,
	}),
}

export default creationToolOeqActions
